import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-emerald-deep text-white py-12 md:py-20 overflow-hidden dna-pattern" data-id="element-60">
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-deep/80 to-emerald-deep/95 z-0" data-id="element-61"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl" data-id="element-62">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-63">
          {/* Image - Mobile: Top, Desktop: Right (but we'll put it on left for better flow or keep it right) */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 order-1 md:order-2 flex justify-center" data-id="element-64">
            <motion.img animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/guBBjP7nB5xnsFAJKdRdie/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS.png" alt="El Reinicio Biológico Bundle" className="w-full h-auto max-h-[280px] md:max-h-none object-contain drop-shadow-2xl" data-id="element-65" />
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2 order-2 md:order-1 text-center md:text-left" data-id="element-66">
            <h1 className="md:text-5xl lg:text-6xl font-display text-gold mb-6 font-[900] text-[40px]" data-id="element-67">
              ¿Vientre Hinchado y Mente Nublada?{' '}
            </h1>

            <p className="md:text-2xl font-body font-light text-warm-white mb-4 text-[24px]" data-id="element-68">
              Recupera tu energía y ligereza de tus 20´s en solo 14 días.
            </p>

            

            <CTAButton text="👉 SÍ, QUIERO MI REINICIO — 26€" className="md:mx-0" data-id="element-69" />
          </motion.div>
        </div>
      </div>
    </section>;
}